import React from 'react';
import Styles from './circle-play-button-styles.scss';
import { PlayRight } from '../icons';
import classNames from 'classnames';
const CirclePlayButton = ({ onClick, background = 'white' }) => {
    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };
    return (React.createElement("div", { className: classNames([Styles.circlePlayButtonWrap, Styles[background]]), onClick: handleClick },
        React.createElement(PlayRight, null)));
};
export default CirclePlayButton;
